import isEmpty from "lodash/isEmpty";

import { removeUndefineds } from "@tsp/tsp-frontend-components/utils";

import { toBackendDate } from "@tsp-core/datetime/utils";

import { QuantityMapKey } from "@tsp-domains/accrual-models/enums";

import { LoadSupplierActualWorkTypesActionParams } from "../actions";
import { LoadSupplierActualWorkTypesRequestParams, LoadSupplierActualWorkTypesResponseData } from "../api";
import { SupplierActualWorkType } from "../types";

export function translateLoadSupplierActualWorkTypesActionParamsToLoadSupplierActualWorkTypesRequestParams(
  params: LoadSupplierActualWorkTypesActionParams,
): LoadSupplierActualWorkTypesRequestParams {
  return removeUndefineds({
    momentAt: toBackendDate(params.momentAt),
    entityType: params.entityType,
    supplierUuids: params.supplierUuids,
    propertyUuid: params.propertyUuid,
    isActiveContracts: params.isActiveContracts,
  });
}

export function translateLoadSupplierActualWorkTypesResponseDataToLoadSupplierActualWorkTypesActionResult(
  response: LoadSupplierActualWorkTypesResponseData,
): Array<SupplierActualWorkType> {
  return response.workTypes.map((supplierActualWorkType) => {
    return {
      id: supplierActualWorkType.id,
      workSubTypes: supplierActualWorkType.workSubTypes.map((supplierActualWorkSubType) => {
        const { accrualModel } = supplierActualWorkSubType;

        return {
          uuid: supplierActualWorkSubType.uuid,
          accrualModel: {
            modelId: accrualModel.model_id,
            unitName: accrualModel.model_unit_name,
            currencyId: accrualModel.currencyId,
            quantityKeys: !isEmpty(accrualModel.quantityFields)
              ? accrualModel.quantityFields
              : accrualModel.isLegacy
                ? [QuantityMapKey.QUANTITY]
                : [QuantityMapKey.EMPTY],
          },
        };
      }),
    };
  });
}
